import { render, staticRenderFns } from "./Bgmyproject.vue?vue&type=template&id=60512de6&scoped=true&"
import script from "./Bgmyproject.vue?vue&type=script&lang=js&"
export * from "./Bgmyproject.vue?vue&type=script&lang=js&"
import style0 from "./Bgmyproject.vue?vue&type=style&index=0&id=60512de6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60512de6",
  null
  
)

export default component.exports